import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useShowDatasetConditions = ({ code }) => {
  const handler = useDispatch();
  return useCallback(({ entity, name }) => handler({
    type: actions.SHOW_DATASET_CONDITIONS, code, entity, name,
  }), [code]);
};

export default {
  useShowDatasetConditions,
};
